/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Campaigns Table component styles
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import styled from 'styled-components';

import { colors } from '../../../../theme';

export const CampaignsTableStyled = styled.div.attrs({
    className: 'campaign-table',
})`

    .campaign-table__prefilter {
        display: flex;
        justify-content: space-between;
        padding: 16px;
        background-color: ${colors.backgroundColorModal};

        .prefilter__value {
            padding: 4px 12px;
            border-radius: 16px;
            background-color: ${colors.backgroundColorDisabled};
        }
    }

    .ReactTable .rt-thead .rt-th {
        border-top: none;

        // hide description column header
        &[data-col-name='description'] .filter {
            visibility: hidden;
            pointer-events: none;
        }
    }
`;
